import styled from "@emotion/styled";

export const Wrapper = styled.div`
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
`;

export const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const Arrow = styled.div`
  position: absolute;
  top: 56px;
  right: 15px;

  display: none;
  content: url(/assets/svg/arrowDecor.svg);

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: block;
  }
`;
